import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Layout from "../components/Layout/Layout";

import Auth from "../pages/Auth/Auth";
import LK from '../pages/LK/LK'
import Main from '../pages/Main'


const regex = /\d+/

export const PATHS = {
    ROOT: "/auth",
    AUTH: {
      
      CONF: `/`,
      LK: "/lk"
    },
  };
  
  export default function Routes() {
    return (
      <BrowserRouter>
          <Layout>
            <Switch>
              <Route exact path={PATHS.ROOT} component={Auth} />
              <Route exact path={PATHS.AUTH.LK} component={LK} />
              <Route path={PATHS.AUTH.CONF} component={Main} />
            </Switch>
          </Layout>
      </BrowserRouter>
    );
  }